angular.module('FlexyBeautyApp.controllers').controller('PatchCtrl',
    ["$scope", "$sce", "CategorySrv", "ProductCategorySrv", "PatchSrv", "$http",
        function ($scope, $sce, CategorySrv, ProductCategorySrv, PatchSrv, $http) {
            $scope.dd = {
                view: {
                    isLoading: false,
                    response: '',
                    currentPatchId: null,
                    currentPatch: null,
                    currentPatchString: '',
                    patchSendingBodyObject: null,
                    patchList: {
                        SERVICE_CATEGORY_LOST_CHILDREN: {
                            id: 1,
                            label: "Catégorie de service a perdu son enfant",
                            parentId: '',
                            childId: '',
                        },
                        PRODUCT_CATEGORY_LOST_CHILDREN: {
                            id: 2,
                            label: "Catégorie de produit a perdu son enfant",
                        },
                        ACTIVITY_DELETE: {
                            id: 3,
                            label: "Supprimer une indisponibilité",
                        }
                    },
                    patchListTwo: null
                }
            };

            $scope.init = function () {
                $scope.dd.view.isLoading = true;
                PatchSrv.list().then(response => {
                    $scope.dd.view.isLoading = false;
                    $scope.dd.view.patchListTwo = response.patches;
                })
            }

            $scope.changePatch = function () {
                $scope.dd.view.currentPatch = JSON.parse($scope.dd.view.currentPatchString);
            }

            $scope.init();

            $scope.stopLoadingChangeResponse = function (response) {
                $scope.dd.view.response = response;
                $scope.dd.view.isLoading = false;
            }

            $scope.lostChildren = function () {
                if ($scope.dd.view.currentPatchId === $scope.dd.view.patchList.SERVICE_CATEGORY_LOST_CHILDREN.id) {
                    $scope.serviceCategoryLostChildren();
                } else if ($scope.dd.view.currentPatchId === $scope.dd.view.patchList.PRODUCT_CATEGORY_LOST_CHILDREN.id) {
                    $scope.productCategoryLostChildren();
                }
            }

            $scope.serviceCategoryLostChildren = function () {
                CategorySrv.patchParentLostChild($scope.ad.companyCode,
                    $scope.dd.view.patchList.SERVICE_CATEGORY_LOST_CHILDREN.parentId,
                    $scope.dd.view.patchList.SERVICE_CATEGORY_LOST_CHILDREN.childId,
                    $scope.stopLoadingChangeResponse,
                    $scope.stopLoadingChangeResponse);
            }

            $scope.productCategoryLostChildren = function () {
                ProductCategorySrv.patchParentLostChild($scope.ad.companyCode,
                    $scope.dd.view.patchList.SERVICE_CATEGORY_LOST_CHILDREN.parentId,
                    $scope.dd.view.patchList.SERVICE_CATEGORY_LOST_CHILDREN.childId,
                    $scope.stopLoadingChangeResponse,
                    $scope.stopLoadingChangeResponse);
            }

            $scope.clearPatch = function () {
                $scope.dd.view.patchSendingBodyObject = null;
            }

            $scope.updateObject = function (fieldLabel, value) {
                $scope.dd.view.patchSendingBodyObject = $scope.dd.view.patchSendingBodyObject === null ? {} : $scope.dd.view.patchSendingBodyObject;
                if ($scope.dd.view.patchSendingBodyObject != null && $scope.dd.view.patchSendingBodyObject.fieldLabel === undefined) {
                    $scope.dd.view.patchSendingBodyObject[fieldLabel] = value;
                }
            }

            $scope.doPatch = function () {
                const body = $scope.dd.view.patchSendingBodyObject;
                const method = $scope.dd.view.currentPatch.method;
                if (method === "POST") {
                    $scope.dd.view.isLoading = true;
                    $http.post($scope.dd.view.currentPatch.url, body).then(response => {
                        $scope.dd.view.response = response;
                        $scope.dd.view.isLoading = false;
                    }).catch(error => {
                        $scope.dd.view.response = error;
                        $scope.dd.view.isLoading = false;
                    });
                }
                if (method === "PATCH") {
                    $scope.dd.view.isLoading = true;
                    $http.patch($scope.dd.view.currentPatch.url, body).then(response => {
                        $scope.dd.view.response = response;
                        $scope.dd.view.isLoading = false;
                    }).catch(error => {
                        $scope.dd.view.response = error;
                        $scope.dd.view.isLoading = false;
                    });
                }
            }

            $scope.deleteActivity = function () {

            }

            $scope.patch = function () {

            }
        }
    ]);



// WEBPACK FOOTER //
// ./js/controllers/pro/configuration/PatchCtrl.js